import { FOURSIGHT_STREAM_VARIANT } from '../constants/bcms';

const hasFourSightStreamVariant = streams => {
  // TODO 2028 check if after URL stream fallback from 4sight to standard this check is respected
  if (!Array.isArray(streams)) {
    return false;
  }

  return streams.some(item => {
    if (!item || typeof item !== 'object') {
      return false;
    }

    const { url, variant } = item;
    return url && variant === FOURSIGHT_STREAM_VARIANT;
  });
};

export default hasFourSightStreamVariant;
